/**
 * Disponibilité d'une mise à jour.
 *
 * Un signal minuscule, en dehors du store : c'est une information du service
 * worker, sans rapport avec l'état du foyer, et la mêler à l'état synchronisé
 * n'apporterait rien.
 */

let available = false;
const listeners = new Set<() => void>();

export function setUpdateAvailable(value: boolean): void {
  if (available === value) return;

  available = value;
  for (const listener of listeners) listener();
}

export function subscribeToUpdate(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function isUpdateAvailable(): boolean {
  return available;
}

/** Applique la mise à jour : le service worker en attente prend la main. */
export async function applyUpdate(): Promise<void> {
  const registration = await navigator.serviceWorker?.getRegistration();
  registration?.waiting?.postMessage({ type: 'SKIP_WAITING' });

  window.location.reload();
}
